export default {
  methods: {

   draw_DataGrid() {

      let tbl = this.table
      
      let table = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, ${this.header.y + this.header.height})`)

      let y_ = 12
      this.tblData.forEach((d,i)=> {

        this.columns.forEach((col,c)=> {

          let alpha = 1+col.tSize*0.26
          // Merge
          if(c==0 && (this.tblData[i-1]) && this.tblData[i][col.code] == this.tblData[i-1][col.code]) return

          if(c<2 && !this.tblData[i+1]) {
            if(c==1) {
              table
              .append('rect')
              .attr('x', 0).attr('y', y_-10)
              .attr('width', tbl.width).attr('height', 20)
              .attr('fill', '#E0E0DF')

              this.gmx_Text(table, '', col.ex/2,  y_+alpha, 10.5, '#000', 'middle', '', 'Grand Total')
            }
          } else if(c==1 && d[col.code] == 'OVERALL'){
            
            table
            .append('rect')
            .attr('x', col.sx).attr('y', y_-10)
            .attr('width', tbl.width - col.sx).attr('height', 20)
            .attr('fill', '#F4F5F5')

            this.gmx_Text(table, '', col.mx,  y_+alpha, 10.5, '#000', 'middle', '', 'Sub Total')

            table
            .append('line')
            .attr('x1', 0).attr('y1', y_+10)
            .attr('x2', tbl.width).attr('y2', y_+10)
            .attr('stroke', '#E0E0DF').attr('stroke-width', .5).attr('opacity', 1)
          } else {
            if(col.unit) {
              table
              .append('rect')
              .attr('x', col.sx).attr('y', y_-9)
              .attr('width', col.width).attr('height', 18)
              .attr('fill', d[col.code] < this.table.repairRate ? '#c6e0b4' : '#ff9b9b')
              .attr('opacity', .5)
            }
            table
            .append('text')
            .attr('x', col.tx).attr('y', y_+alpha)
            .attr('font-size', col.tSize)
            .attr('fill', d[this.columns[1].code] == 'OVERALL' ? '#000' : col.tColor)
            .attr('text-anchor', col.align)
            .text(d[col.code] + col.unit)
          }
        })

        y_ = y_ + tbl.lineHeight
      })

      table
      .append('line')
      .attr('x1', 0).attr('y1', y_+10-tbl.lineHeight)
      .attr('x2', tbl.width).attr('y2', y_+10-tbl.lineHeight)
      .attr('stroke', '#757575').attr('stroke-width', .5).attr('opacity', 1)

      
    },


  }
}